import { is } from "ramda";
import moment from "moment";
import { getLangToSend } from ".";

export default function parseValueToAppointment(
  data,
  appointmentType,
  stlocId
) {
  const phone =
    data && data.phone && data.phone !== ""
      ? Number.parseInt(data.phone)
      : null;
  const appointment = {
    appointmentType,
    stlocId: stlocId,
    startDate: getStartDate(data),
    appId: "Web",
    lang: getLangToSend(),
    section: "WOMAN",
    customer: {
      firstName: data.name,
      lastName: data.surname,
      email: data.email,
      phone,
    },
    isTermsAndConditionsAccepted: true,
    dateTermsAndConditionsAccepted: getNowDate(),
  };
  return appointment;
}

function getNowDate() {
  return moment.utc().format();
}

function getStartDate(data) {
  // const utcDate = moment
  //   .utc(
  //     `${data.day} ${is(Array, data.time) ? data.time[0] : data.time}`,
  //     "DD/MM/YYYY HH:mm"
  //   )
  //   .format();
  // This one parse the date introduced as UTC, not the local date
  const utcDate = moment(
    `${data.day} ${is(Array, data.time) ? data.time[0] : data.time}`,
    "DD/MM/YYYY HH:mm"
  )
    .utc()
    .format();
  return utcDate;
}
